import $ from 'cash-dom';

import Matter from 'matter-js';

Matter.Common.logLevel = 0;

// Gsap and plugins
import gsap from 'gsap';
import CSSPlugin from 'gsap/CSSPlugin';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import SplitText from 'gsap/SplitText';
import Observer from 'gsap/Observer';
import MorphSVGPlugin from 'gsap/MorphSVGPlugin';

gsap.registerPlugin(CSSPlugin, ScrollToPlugin, ScrollTrigger, ScrollSmoother, Observer, SplitText, MorphSVGPlugin);


// Light gallery
// require( 'lightgallery.js' );
// require( 'lg-zoom.js' );
// require( 'lg-hash.js' );

// Globals
global.$ = $;
global.gsap = gsap;
global.ScrollSmoother = ScrollSmoother;
global.ScrollTrigger = ScrollTrigger;
global.Observer = Observer;
global.SplitText = SplitText;
global.MorphSVGPlugin = MorphSVGPlugin;

import Config from 'configs/Config';
import SupportManager from 'configs/SupportManager';

import Router from 'controllers/Router';
import Main from 'controllers/Main';

import PagesController from 'controllers/PagesController';

;
import * as Components0 from '../../../components/pages/404/js/__.js'; import * as Components1 from '../../../components/pages/agency/js/__.js'; import * as Components2 from '../../../components/pages/contact/js/__.js'; import * as Components3 from '../../../components/pages/page/js/__.js'; import * as Components4 from '../../../components/pages/project/js/__.js'; import * as Components5 from '../../../components/pages/services/js/__.js'; import * as Components6 from '../../../components/pages/team/js/__.js'; import * as Components7 from '../../../components/partials/footer/js/__.js'; import * as Components8 from '../../../components/partials/title/js/__.js'; import * as Components9 from '../../../components/partials/transition-images/js/__.js'; import * as Components10 from '../../../components/partials/transition-lines/js/__.js'; import * as Components11 from '../../../components/partials/transition-links/js/__.js'; import * as Components12 from '../../../components/partials/transition-titles/js/__.js'; import * as Components13 from '../../../components/statics/cookies/js/__.js'; import * as Components14 from '../../../components/statics/header/js/__.js'; import * as Components15 from '../../../components/statics/infos-message/js/__.js'; import * as Components16 from '../../../components/statics/main-loader/js/__.js'; let Components = [Components0, Components1, Components2, Components3, Components4, Components5, Components6, Components7, Components8, Components9, Components10, Components11, Components12, Components13, Components14, Components15, Components16];
;


export const App = new class {


	constructor() {

	}


	init() {
		Promise.all([
			Config.init(),
			Main.init(),
			// SupportManager.init()
		]).then(() => {
			Router.init();
		});
	}


};


$(App.init());
